export const splitString = new Set(['+', '-', '*', '%', '=', ',', '，'])
